import React, { FC, ReactNode } from "react"
import { PopperProps, Tooltip } from "@mui/material"

interface TooltipWrapperProps {
  children: ReactNode
  title: ReactNode
  placement?: PopperProps["placement"]
  enterDelay?: number
  leaveDelay?: number
  arrow?: boolean
  tooltipProps?: object
}

export const TooltipWrapper: FC<TooltipWrapperProps> = ({
  children,
  title,
  placement = "top",
  enterDelay = 500,
  leaveDelay = 200,
  arrow = false,
  tooltipProps = {},
  ...rest
}) => {
  if (!title) {
    return children
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      arrow={arrow}
      {...tooltipProps}
    >
      {React.isValidElement(children) ? (
        children
      ) : (
        <span {...rest}>{children}</span>
      )}
    </Tooltip>
  )
}
